import { render, staticRenderFns } from "./imgQ.vue?vue&type=template&id=d29f319c"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d29f319c')) {
      api.createRecord('d29f319c', component.options)
    } else {
      api.reload('d29f319c', component.options)
    }
    module.hot.accept("./imgQ.vue?vue&type=template&id=d29f319c", function () {
      api.rerender('d29f319c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgQ.vue"
export default component.exports